import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa";
import { HiMail, HiMenu } from "react-icons/hi";
import { MdCall } from "react-icons/md";
import { CgClose } from "react-icons/cg";
import { firebase, db } from "../firebaseConfig";
import { useCart } from "react-use-cart";
import { Navlinks } from "./Data";


const ResponsiveMenu = ({ showMenu, setShowMenu, theme, setTheme }) => {
  const [user, setUser] = useState(null);
  const [profileData, setProfileData] = useState(null);

  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged((authUser) => {
      setUser(authUser || null);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (!user) { setProfileData(null); return; }
    const unsubscribe = db.collection("userss").doc(user.uid)
      .onSnapshot((doc) => {
        if (doc.exists) setProfileData(doc.data());
      });
    return () => unsubscribe();
  }, [user]);

  const { isEmpty, totalItems } = useCart();

  console.log("showMenu", showMenu);
  return (
    <div
      className={`${
        showMenu ? "left-0" : "-left-[100%]"
      } fixed bottom-0 top-0 z-[99999] text-start flex h-screen w-[75%] flex-col justify-between bg-white dark:bg-gradient-to-r from-black to-amber-900 dark:text-white px-8 pb-6 pt-10 text-black transition-all duration-75 md:hidden rounded-r-xl shadow-md`}
    >

      <div className="card">
        <Link
         to={user ? '/profile' : '/'}
         onClick={()=>setShowMenu(false)}
        className="flex items-center justify-start gap-3">
          {(profileData?.profileImage || user?.photoURL) ? (
            <img
              src={profileData?.profileImage || user?.photoURL}
              alt="Profile"
              className="h-14 w-14 rounded-full object-cover border-2 border-amber-400 flex-shrink-0"
            />
          ) : user ? (
            <div className="h-14 w-14 rounded-full bg-amber-500 text-white flex items-center justify-center text-2xl font-bold flex-shrink-0">
              {user.displayName?.[0]?.toUpperCase() || user.email?.[0]?.toUpperCase() || "U"}
            </div>
          ) : (
            <FaUserCircle size={50} />
          )}
          <div>
            <h1 className="font-bold text-base">Hello Boss</h1>
            <p className="text-sm text-slate-500 dark:text-slate-400 truncate max-w-[140px]">
              {user ? (user.displayName || user.email) : "Premium user"}
            </p>
          </div>
        </Link>
        <nav className="mt-10">
          <ul className="space-y-4 text-sm">
            {Navlinks.map((data, index) => (
              <li
              key={index}
              onClick={()=>setShowMenu(false)}
              >
                <Link 
                  to={data.link} 
                  className="mb-5 inline-block text-sm"
                  onClick={() => {
                    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
                  }}
                >
                  {data.name}
                </Link>
              </li>
            ))}
               <a href="mailto:support@vethinteriors.com">
        <HiMail className="text-2xl cursor-pointer" />
      </a>
      <a href="tel:+2348106079897">
        <MdCall className="text-2xl mt-5 cursor-pointer" />
      </a>
      <a
        href="https://wa.me/2348106079897"
        target="_blank"
        rel="noopener noreferrer"
        className="text-sm text-green-600 dark:text-green-400 font-semibold mt-3 inline-flex items-center gap-1"
      >
        💬 WhatsApp Us
      </a>
          </ul>
        </nav>
      {/* <div className=' rounded-full p-2'>
          {theme === "dark" ? (
              <BiSolidSun onClick={() => setTheme("light")} className="text-2xl text-white cursor-pointer" />
                ) : (
             <BiSolidMoon onClick={() => setTheme("dark")} className="text-2xl cursor-pointer" />
          )}
      </div> */}
      </div>
      <div className="footer">
        <h1>
          Made with ❤ For <a href="/">
          You</a>{" "}
        </h1>
      </div>
    </div>
  );
};

export default ResponsiveMenu;
